import { debugLog } from "../utils/debugLogger";
import { getRuntimeConfig } from "./runtimeConfig";

export const polarService = {
  /**
   * EXPLICIT RUNTIME VERIFICATION
   * Logs values from the loaded runtime config.
   */
  logEnvironment() {
    let config;
    try {
        config = getRuntimeConfig().polar;
    } catch (e) {
        console.error("Polar Service: Runtime config not loaded yet.");
        return;
    }

    const report = {
      values: {
        orgSlug: config.orgSlug,
        productIdMonthly: config.productIdMonthly,
        productIdYearly: config.productIdYearly
      },
      meta: {
        hasOrgSlug: !!config.orgSlug,
        hasMonthly: !!config.productIdMonthly,
        hasYearly: !!config.productIdYearly
      }
    };

    console.log("POLAR_RUNTIME_CHECK", report);
    return report;
  },

  /**
   * Creates a checkout session via the backend and redirects the user.
   */
  async openCheckout(productId: string, userEmail: string, userId: string) {
    const config = getRuntimeConfig().polar;
    const ORG_SLUG = config.orgSlug;

    this.logEnvironment();

    let plan = '';
    if (productId === config.productIdMonthly) plan = 'monthly';
    else if (productId === config.productIdYearly) plan = 'yearly';

    if (!plan) {
      const errorMsg = "Polar Error: Could not match Product ID to a known Plan.";
      console.error(errorMsg, { productId, config });
      alert("Configuration Error: Invalid Product ID. Please contact support.");
      return;
    }

    debugLog("POLAR", "Requesting Checkout Session", { plan, userId });

    try {
        const successUrl = `${window.location.origin}/library?checkout=success`;
        
        const response = await fetch('/api/polar/checkout', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                plan,
                userId,
                email: userEmail,
                successUrl
            })
        });

        if (!response.ok) {
            const errData = await response.json();
            throw new Error(errData.error || 'Failed to create checkout session');
        }

        const data = await response.json();
        const checkoutUrl = data.url;

        if (!checkoutUrl) {
            throw new Error("API returned success but no URL provided.");
        }

        debugLog("POLAR", "Redirecting to Polar...", { url: checkoutUrl });
        window.location.href = checkoutUrl;

    } catch (e: any) {
        console.error("Polar Checkout Failed:", e);
        alert("Failed to start checkout. Please try again.");
    }
  },

  /**
   * Returns the URL for the customer portal.
   */
  getCustomerPortalUrl() {
    try {
        const config = getRuntimeConfig().polar;
        if (!config.orgSlug) return "https://polar.sh";
        return `https://polar.sh/${config.orgSlug}/portal`;
    } catch (e) {
        return "https://polar.sh";
    }
  },

  getProducts() {
    try {
        const config = getRuntimeConfig().polar;
        return {
            monthly: config.productIdMonthly,
            yearly: config.productIdYearly
        };
    } catch (e) {
        return { monthly: '', yearly: '' };
    }
  }
};